define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/query",
	"csi/heading/stateColorResolver",
	"csi/html",
	"csi/html/StateWidget",
	"csi/locale",
	"csi/reflection",
	"csi/xml",
	"SourcingOrders",
	"csi/_base/underscore"
], function(declare,domClass,query,stateColorResolver,html,StateWidget,locale,reflection,xml,SourcingOrders,_) {

	var actions = [
	    "POToNegotiation",
	    "POBackToNegotiation",
	    "POToReady",
	    "POToIssued",
	    "POToClosed"
	];

	return declare(StateWidget, {

		_refreshArrows: function() {
			var config  = reflection.getObject(SourcingOrders.CONFIG);
			var mapDefs = this.defView.defsByKey;
			var currentState = this.getViewNode().State;

			_.each(actions, function(id) {
				if(!mapDefs[id])  // Not all id defined on actions above are on CustomerPO view
					return;

				if (SourcingOrders.poStateChangeHasWorkflow(config, id, currentState)) {
					mapDefs[id].m_action.m_orig_name = mapDefs[id].m_action.m_name; // hang on to it in case we need it back
					mapDefs[id].m_action.m_name = locale.resource("POActionByWorkflow", [mapDefs[id].m_action.m_name]); // [action] by Workflow
				} else {
					// see if mapDefs[id].m_action.m_name ends in "by Workflow".  if so, strip off "by Workflow"
					if (mapDefs[id] && mapDefs[id].m_action.m_orig_name !== undefined)
						mapDefs[id].m_action.m_name = mapDefs[id].m_action.m_orig_name; // reset
				}
			});

		},

		_resolveView: function() {
			this.inherited(arguments);
			this._refreshArrows();
		},


		_redraw: function() {
			this._refreshArrows();
			this.inherited(arguments);
		},

		_processHtml: function(/*csi.def.Context*/ctx, /*DOMNode*/dom) {
			// summary: apply styling for active state
			this.inherited(arguments);
			
			const node = ctx.getNode();
			const css = stateColorResolver.getStateCss(node);
			const stateEnumValue = xml.enumGetText(node.State);
			
			var eAbandoned = query(".abandoned", dom)[0];
			if (eAbandoned) {
				html.text(eAbandoned, locale.getEnumName("PurchasedOrderState:Abandoned", true));
				domClass.add(eAbandoned, css);
			} else {
				var eDraft = query(".draft", dom)[0];
				var eNegotiation = query(".negotiation", dom)[0];
				var eReady = query(".ready", dom)[0];
				var eIssued = query(".issued", dom)[0];
				var eClosed = query(".closed", dom)[0];

				html.text(eDraft, locale.getEnumName("PurchasedOrderState:Draft", true));
				if(eNegotiation)
					html.text(eNegotiation, locale.getEnumName("PurchasedOrderState:Negotiation", true));
				html.text(eReady, locale.getEnumName("PurchasedOrderState:Ready", true));
				html.text(eIssued, locale.getEnumName("PurchasedOrderState:Issued", true));
				html.text(eClosed, locale.getEnumName("PurchasedOrderState:Closed", true));

				switch (stateEnumValue) {
					case "Draft": domClass.add(eDraft, css); break;
					case "Negotiation": domClass.add(eNegotiation, css); break;
					case "Ready": domClass.add(eReady, css); break;
					case "Issued": domClass.add(eIssued, css); break;
					case "Closed": domClass.add(eClosed, css); break;
				}
			}
		}
	});
});